import React, {useState} from 'react'

  
  const QuestionAnsbot =  ({ selectedFaq, onClose, onUpdateVariation }) => {
    const [variations, setVariations] = useState([
      "What feedback options are available?",
      "What types of feedback can I give?",
      "How can I provide feedback?",
      "What can I give feedback on?",
      "Where can I submit my feedback?",
      "What feedback categories are there?",
      "Can I report inappropriate content?",
      "What should I include in my feedback?",
      "Is there a way to delete feedback?",
      "How do I report predictions?",
      "What happens after I send feedback?",
    ]);
  
    const [editingIndex, setEditingIndex] = useState(null);
  
    const handleChange = (index, value) => {
      const updated = [...variations];
      updated[index] = value;
      setVariations(updated);
      onUpdateVariation(selectedFaq.id, updated);
    };
  
    return (
      <div className="position-fixed end-0 top-0 bg-white p-4 shadow" style={{ width: "30%", height: "100%", overflowY: "scroll", zIndex: 1050 }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>Edit Question & Answer</h5>
          <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>X</button>
        </div>
  
        <div>
          <strong>Question variations</strong>
          <ul className="list-group mt-2">
            {variations.map((text, index) => (
              <li key={index} className="list-group-item d-flex justify-content-between align-items-start">
                {editingIndex === index ? (
                  <input
                    type="text"
                    value={text}
                    className="form-control"
                    onChange={(e) => handleChange(index, e.target.value)}
                    onBlur={() => setEditingIndex(null)}
                    autoFocus
                  />
                ) : (
                  <div onClick={() => setEditingIndex(index)} style={{ cursor: "pointer", flexGrow: 1 }}>
                    {text}
                  </div>
                )}
                <span className="badge bg-secondary ms-2">{Math.floor(Math.random() * 20 + 20)}/70</span>
              </li>
            ))}
          </ul>
        </div>
  
        <div className="mt-4">
          <strong>Answer</strong>
          <div className="border p-3 mt-2">
            {selectedFaq?.answer || "You can provide feedback on various aspects such as predictions, search results, and app performance."}
          </div>
        </div>
      </div>
    );
  };
export default QuestionAnsbot